import React from 'react';

import Layout from '../../components/LayoutWoodbury';
import CareersTemplate from '../../templates/careersTemplate';

const Careers = () => {
  return (
    <Layout pageTitle='careers'>
      <CareersTemplate location='woodbury' />
    </Layout>
  );
};

export default Careers;
